<template>
  <vx-card class="payment-document main-box top-zero-radius md:w-1/2">
    <div class="sources">
      <div class="label">{{ $t('treasury.receive.document.labels.sources') }}</div>
      <ul>
        <li>
          <div class="row-number">1</div>
          <div class="name">{{ payer.name }}</div>
          <div class="price" v-if="price !== 0" :class="{'text-danger': price < 0, 'text-success': price >= 0}">{{ addComma(Math.abs(finalPrice || price)) }} تومان</div>
        </li>
      </ul>
    </div>

    <div class="destinations mt-4">
      <div class="label">{{ $t('treasury.receive.document.labels.destinations') }}</div>
      <ul>
        <li>
          <div class="row-number">1</div>
          <div class="name">{{ `${payee.name || ''} ${payee.family || ''}` }}</div>
          <div v-if="price !== 0" class="price" :class="{'text-danger': price < 0, 'text-success': price >= 0}">{{ addComma(price) }} تومان</div>
        </li>
      </ul>
    </div>

    <div class="details mt-4">
      <div class="label">{{ $t('treasury.payment.document.labels.details') }}</div>
      <ul>
        <li v-for="(detail, detail_index) in details" :key="detail_index">
          <div class="row-number">{{ detail_index + 1 }}</div>
          <div class="key">{{ detail.key }}</div>
          <div class="value" :class="detail.classes">{{ detail.value }}</div>
        </li>
      </ul>
    </div>

    <custom-dialog ref="deleteDocumentConfirmation"
                   :title="`${$t('treasury.payment.document.confirmations.delete.title')}`"
                   :body="`${$t('treasury.payment.document.confirmations.delete.body')}`"
                   @accept="deleteDocument"/>

    <button v-show="false" id="DeleteDocumentBTN" @click="$refs.deleteDocumentConfirmation.showDialog()"/>
  </vx-card>
</template>

<script>
import CustomDialog from '../../../../../components/customDialog/customDialog'
import {deleteDocument, getPayment} from '../../../../../http/requests/documents'
import {addComma} from '../../../../../assets/js/functions'

export default {
  name: 'paymentDocument',
  components: {CustomDialog},
  metaInfo () {
    return {
      title: this.$route.params.id ? this.$t('treasury.payment.document.dynamicTitle', {
        docNumber: this.$route.params.id
      }) : this.$t('treasury.payment.document.title')
    }
  },
  data () {
    return {
      sourceTypesMapper: {
        'User': this.$t('treasury.payment.types.user'),
        'Bank': this.$t('treasury.payment.types.bank'),
        'Cash': this.$t('treasury.payment.types.cash'),
        'Storeroom': this.$t('treasury.payment.types.storeroom'),
        'PaymentGateway': this.$t('treasury.payment.types.paymentGateway')
      },
      paymentTypes: {
        ctc: this.$t('treasury.payment.bankTypes.card'),
        iban: this.$t('treasury.payment.bankTypes.sheba')
      },
      payee: [],
      payer: [],
      price: 0,
      finalPrice: 0,
      details: [],
      actions: {
        leftToolbar: [
          {
            id: 'DeleteDocumentBTN',
            permission: 'payment.delete',
            color: 'danger',
            icon: 'TRASH',
            iconPack: 'useral'
          },
          {
            id: {name: 'print-payment-page', params: {id: this.$route.params.id}},
            type: 'new-page-link',
            icon: 'PRINT',
            iconPack: 'useral'
          },
          {
            id: {name: 'treasuryPayment'},
            type: 'link',
            icon: 'CHEVRON_LEFT',
            iconPack: 'useral'
          }
        ]
      }
    }
  },
  created () {
    setTimeout(() => {
      this.$store.dispatch('updateNavbarActions', this.actions)
      this.$store.dispatch('updateContentNavbarStyle', 'sticky')
      this.$store.dispatch('updateContentNavbarClass', 'md:w-1/2 mx-auto')
      this.$store.dispatch('setPageTitle', this.$route.params.id ? this.$t('treasury.payment.document.dynamicTitle', {
        docNumber: this.$route.params.id
      }) : this.$t('treasury.payment.document.title'))
    }, 50)

    this.getDocument()
  },
  methods: {
    getDocument () {
      getPayment(this.$route.params.id).then(response => {
        const document = response.data.data
        this.payee = document.payee
        this.payer = document.payer
        this.price = document.price
        this.finalPrice = document.final_price || document.price

        this.details.push({
          key: this.$t('treasury.payment.document.labels.creator'),
          value: document.creator.name
        })
        this.details.push({
          key: this.$t('treasury.payment.document.labels.date'),
          value: document.date,
          classes: 'rtl'
        })
        if (document.payment_type) {
          this.details.push({
            key: this.$t('treasury.payment.document.labels.paymentType'),
            value: this.paymentTypes[document.payment_type]
          })
        }
        if (document.wage) {
          this.details.push({
            key: this.$t('treasury.payment.document.labels.wage'),
            value: `${addComma(document.wage)} تومان`,
            classes: 'text-danger ltr'
          })
        }
        this.details.push({
          key: this.$t('treasury.payment.document.labels.description'),
          value: document.description
        })
      })
    },
    addComma (val) {
      return addComma(val)
    },
    deleteDocument () {
      deleteDocument(this.$route.params.id, 'payment').then(() => {
        this.$vs.notify({
          title: this.$t('alert.message.title'),
          text: this.$t('treasury.payment.document.notifications.delete.success'),
          time: 2400,
          color: 'success',
          icon: 'icon-check',
          iconPack: 'feather'
        })
        this.$router.replace({name: 'treasuryPayment'})
      }).catch(() => {
        this.$vs.notify({
          title: this.$t('alert.error.title'),
          text: this.$t('treasury.payment.document.notifications.delete.error'),
          time: 2400,
          color: 'danger',
          icon: 'icon-alert-circle',
          iconPack: 'feather'
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.payment-document {

  .sources, .destinations, .details {

    .label {
      font-size: 14px;
      font-weight: 600;
      line-height: 50px;
      border-bottom: 1px solid #cecece;
    }

    ul {

      li {
        font-size: 13px;
        line-height: 35px;
        background: #cecece40;
        display: flex;
        flex-direction: row;

        .row-number {
          min-width: 50px;
          text-align: center;
        }

        .name {
          flex: 3;
        }

        .price {
          flex: 1;
          text-align: center;
        }

        .key {
          flex: 1;
          text-align: center;
        }

        .value {
          flex: 1;
          text-align: center;
        }

        &:nth-child(2n) {
          background: #cecece10;
        }
      }
    }
  }
}
</style>
